module.exports = __webpack_public_path__ + "img/dd804f3.jpg";